/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Overlay_Visual_OnlyInputs */

const bn_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শুধুমাত্র ভিজ্যুয়াল`)
};

const de_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NUR VISUELL`)
};

const el_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΜΟΝΟ ΟΠΤΙΚΟ`)
};

const en_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VISUAL ONLY`)
};

const es_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÓLO VISUALES`)
};

const fr_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VISUEL UNIQUEMENT`)
};

const hi_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल दृश्य`)
};

const hu_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSAK VIZUÁLIS`)
};

const id_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HANYA VISUAL`)
};

const it_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOLO VISIVA`)
};

const ja_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビジュアルのみ`)
};

const ko_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시각적인 것만`)
};

const nl_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ALLEEN VISUEEL`)
};

const pl_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TYLKO WIZUALNE`)
};

const pt_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SOMENTE VISUAL`)
};

const ru_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТОЛЬКО ВИЗУАЛЬНО`)
};

const sv_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ENDAST VISUELL`)
};

const tr_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SADECE GÖRSEL`)
};

const uk_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ТІЛЬКИ ВІЗУАЛЬНЕ`)
};

const vi_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHỈ HÌNH ẢNH`)
};

const zh_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅视觉效果`)
};

const zh_hant_cipher_overlay_visual_only = /** @type {(inputs: Cipher_Overlay_Visual_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`僅視覺效果`)
};

/**
* | output |
* | --- |
* | "VISUAL ONLY" |
*
* @param {Cipher_Overlay_Visual_OnlyInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_overlay_visual_only = /** @type {((inputs?: Cipher_Overlay_Visual_OnlyInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Overlay_Visual_OnlyInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_overlay_visual_only(inputs)
	if (locale === "de") return de_cipher_overlay_visual_only(inputs)
	if (locale === "el") return el_cipher_overlay_visual_only(inputs)
	if (locale === "en") return en_cipher_overlay_visual_only(inputs)
	if (locale === "es") return es_cipher_overlay_visual_only(inputs)
	if (locale === "fr") return fr_cipher_overlay_visual_only(inputs)
	if (locale === "hi") return hi_cipher_overlay_visual_only(inputs)
	if (locale === "hu") return hu_cipher_overlay_visual_only(inputs)
	if (locale === "id") return id_cipher_overlay_visual_only(inputs)
	if (locale === "it") return it_cipher_overlay_visual_only(inputs)
	if (locale === "ja") return ja_cipher_overlay_visual_only(inputs)
	if (locale === "ko") return ko_cipher_overlay_visual_only(inputs)
	if (locale === "nl") return nl_cipher_overlay_visual_only(inputs)
	if (locale === "pl") return pl_cipher_overlay_visual_only(inputs)
	if (locale === "pt") return pt_cipher_overlay_visual_only(inputs)
	if (locale === "ru") return ru_cipher_overlay_visual_only(inputs)
	if (locale === "sv") return sv_cipher_overlay_visual_only(inputs)
	if (locale === "tr") return tr_cipher_overlay_visual_only(inputs)
	if (locale === "uk") return uk_cipher_overlay_visual_only(inputs)
	if (locale === "vi") return vi_cipher_overlay_visual_only(inputs)
	if (locale === "zh") return zh_cipher_overlay_visual_only(inputs)
	return zh_hant_cipher_overlay_visual_only(inputs)
});